import request from '@/sheep/request';

// 分类
export interface Place {
	id : string
	name : string
	shortName : string
	icon : string
	picUrl ?: string
	picUrls ?: string
	description ?: string
	type ?: string
	latitude ?: number
	longitude ?: number
	province ?: string
	city ?: string
	district ?: string
	trendingScore ?: number
	viewCount ?: number
	wishCount ?: number
	sacredValue ?: number
	keywords ?: string
	tags ?: string[]
	distance ?: number
	shareContent ?: string
}

// 查询最近许愿地点
export const getNearPlace = (query : any) => {
	return request({
		url: '/wish/place/get/near',
		method: 'GET',
		params: query
	});
}

// 查询分类精简列表
export const getPlaceSimpleList = () => {
	return request({
		url: '/wish/place/list-simple',
		method: 'GET',
	});
}

export const getPlacePage = (query : any) => {
	return request({
		url: '/wish/place/page',
		method: 'GET',
		params: query
	});
}

export const getPlaceRandom = (query : any) => {
	return request({
		url: '/wish/place/random',
		method: 'GET',
		params: query
	});
}

// 查询分类列表
export const getPlaceList = (query ?: { latitude ?: number, longitude ?: number }) => {
	return request({
		url: '/wish/place/list',
		method: 'GET',
		params: query
	});
}

export const getPlaceListByType = (typeId : number, longitude : number, latitude : number) => {
	return request({
		url: '/wish/place/list/type',
		method: 'GET',
		params: { typeId, longitude, latitude }
	});
}

// 查询地点详情
export const getPlaceDetail = (id : string) => {
	return request({
		url: '/wish/place/get',
		method: 'GET',
		params: { id }
	});
}